export { default } from './FeatureEdInfoBox';
